import{isObject}from"./is_object.js";
import{setNonEnumProp}from"./set.js";
import{validateError}from"./validate.js";


export const ponyfillCause=(error,parameters)=>{
validateError(error);

if(
hasCause(parameters)&&
!("cause"in error&&parameters.cause===error.cause))
{
setNonEnumProp(error,"cause",parameters.cause)
}
};


const hasCause=(parameters)=>isObject(parameters)&&"cause"in parameters;